<router-outlet></router-outlet>

<div [hidden]="!isLoggedInCheck()">
    <!-- [hidden]="!loggedIn() || !token?.permission?.chatAI" -->
    <img src="assets/img/luca1.png" alt="" id="chat-circle" (click)="openChat()" [hidden]="!token?.permission?.chatAI">

    <!-- [hidden]="!loggedIn() || !permission?.chatAI" -->
    <div class="chat-box" [hidden]="!token?.permission?.chatAI">
        <div class="chat-box-header align-items-center py-2">
            <img src="assets/img/luca1.png" width="35px" class="mx-2" />
            <div>
                <span class="chat-box-toggle text-secondary" (click)="clearChat()"><i class="ti ti-x"></i></span>
                <span class="chat-box-toggle text-secondary" (click)="closeChat()"><i class="ti ti-minus"></i></span>
            </div>
        </div>
        <div class="chat-box-body messages">
            <div class="chat-box-overlay messages-content"> </div>
        </div>
        <div>
            <form>
                <input type="text" class="chat-input" id="chat-input" placeholder="Send a message..." />
                <button type="submit" class="chat-submit" (click)="chatQuery()" id="chat-submit"><i
                        class="material-icons">send</i></button>
            </form>
        </div>
    </div>
</div>


<div class="card p-2" id="liveToast" hidden>
    <div class="card-header p-2">
        <div class="d-flex align-items-center">
            <div class="flex-shrink-0">
                <span class="pc-micon">
                    <i class="ti ti-truck-delivery text-primary"></i>
                </span>
            </div>
            <div class="flex-grow-1 mx-2">
                <h6 class="my-1">Trailer Arrived</h6>
            </div>
            <div class="flex-shrink-0">
                <small class="text-muted mb-0" id="toastMsg">5 min ago</small>
            </div>
        </div>
    </div>
    <div class="card-body p-2">
        <span class="f-12">
            Trailer No <span class="text-primary" id="toastTitle"> </span> has arrived at the gate. 
            Please fill the necessary details.
        </span>
        <div class="col-md-12 text-end">
            <button id="toastCloseBtn" type="button" class="btn btn-light-danger btn-sm mb-1 me-1">Close</button>
            <button id="toastFillBtn" type="button" class="btn btn-light-primary btn-sm mb-1 me-1">Fill Details</button>
        </div>
    </div>
</div>